// Borrower Context State

import { Injectable } from '@angular/core';
import { State, Selector, Action, StateContext } from '@ngxs/store';
import { GetBorrowerContext } from './borrower-context.actions';
import { BorrowerContextService } from 'app/services/ai/borrower-state/borrower-context/borrower-context.service';
import { catchError, of, tap } from 'rxjs';

export class BorrowerContextModel {
    borrowerId: number;
    answer: string;
    loading: boolean;
    error: string | null;
}

@State<Partial<BorrowerContextModel>>({
    name: 'borrowerContext',
    defaults: {
        borrowerId: undefined,
        answer: '',
        loading: true,
        error: '',
    }
})

@Injectable()

export class BorrowerContextState {

    @Selector()
    static answer(state: BorrowerContextModel) {
        return state.answer;
    }

    @Selector()
    static loading(state: BorrowerContextModel) {
        return state.loading;
    }

    @Selector()
    static error(state: BorrowerContextModel) {
        return state.error;
    }

    @Selector()
    static fullContext(state: BorrowerContextModel) {
        return state;
    }

    constructor(private borrowerContextService: BorrowerContextService) { }

    @Action(GetBorrowerContext)
    getBorrowerContext(ctx: StateContext<BorrowerContextModel>, { borrowerId }: GetBorrowerContext) {
        return this.borrowerContextService.getBorrowerContext(borrowerId).pipe(
            tap((res) => {
                ctx.patchState({
                    borrowerId: res.borrowerId,
                    answer: res.answer,
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: 'Failed to load borrower context.'
                });
                return of();
            })
        );
    }
}